<template>
  <div class="row">
    <div class="col-xl-3 mb-4">
      <!--begin::Filter-->
      <div class="card card-custom bg-light gutter-b card-stretch">
        <!--begin::Header-->
        <div class="card-header border-0 pt-5 pl-5 pr-5">
          <div class="card-title">
            <div class="card-label">
              <div class="font-weight-bolder">Filter</div>
              <div class="font-size-sm text-muted mt-2">Pilih menu dibawah</div>
            </div>
          </div>
          <div class="card-toolbar" />
        </div>
        <!--end::Header-->
        <!--begin::Body-->
        <div class="card-body d-flex flex-column p-5">
          <!--begin::Items-->
          <div class="form-group">
            <label>Tanggal Vaksinasi</label>
            <DatePicker
              v-model="dateRange"
              value-type="format"
              format="YYYY-MM-DD"
              range
              placeholder="Pilih tanggal"
              input-class="form-control"
              :disabled-date="disabledBeforeStartAndAfterToday"
            />
          </div>
          <!--end::Items-->
          <!--begin::Items-->
          <div class="form-group">
            <label>Wilayah</label>
            <Multiselect
              v-if="isRegionReady"
              class="select"
              :value="selectedRegion"
              :options="regionOptions"
              :custom-label="nameWithLang"
              @input="updateSelectedRegion"
              @select="onSelect"
              placeholder="Select one"
              label="name"
              track-by="name"
              deselectLabel="x"
              selectLabel=""
            />
          </div>
          <!--end::Items-->
          <!--begin::Items-->
          <div class="form-group mt-0 mb-10">
            <label>Items per Page</label>
            <select class="form-control" v-model="pageSize">
              <option v-for="size in pageSizes" :key="size" :value="size">
                {{ size }}
              </option>
            </select>
          </div>
          <!--end::Items-->
          <div class="d-flex flex-row-reverse">
            <button
              type="reset"
              class="btn btn-primary btn-sm ml-3"
              @click="
                page = 1
                retrieveReports()
              "
            >
              Submit
            </button>
            <b-button variant="success" class="btn-sm" @click="handleDownload">
              Download Filtered
            </b-button>
          </div>
        </div>
        <!--end::Body-->
      </div>
      <!--end::Filter-->
    </div>
    <div class="col-xl-9 mb-4">
      <div class="card card-custom gutter-b card-stretch">
        <!--begin::Header-->
        <div class="card-header border-0 py-5">
          <h3 class="card-title align-items-start flex-column">
            <span class="card-label font-weight-bolder text-dark">
              Progress Laporan Harian
            </span>
            <span class="text-muted mt-3 font-weight-bold font-size-sm">
              Daftar laporan vaksinasi hingga hari ini
            </span>
          </h3>
          <div class="card-toolbar">
            <!--begin::Search Form-->
            <b-form inline>
              <div class="input-icon">
                <input
                  type="text"
                  class="form-control"
                  placeholder="Search..."
                  v-model="searchTitle"
                />
                <span>
                  <i class="flaticon2-search-1 text-muted" />
                </span>
              </div>

              <button
                class="btn btn-primary px-6 font-weight-bold ml-3"
                type="button"
                @click="
                  page = 1
                  retrieveReports()
                "
              >
                Search
              </button>

              <button
                class="btn btn-icon btn-primary ml-3"
                type="button"
                @click="refreshData()"
              >
                <i class="flaticon2-refresh-button" />
              </button>
            </b-form>
            <!--end::Search Form-->
          </div>
        </div>
        <!--end::Header-->
        <!--begin::Body-->
        <div class="card-body py-0 pb-10">
          <b-alert
            v-if="isError"
            show
            dismissible
            fade
            variant="danger"
            class="alert-light-danger alert-custom"
          >
            <div class="alert-icon"><i class="flaticon-warning" /></div>
            <div class="alert-text">
              Data yang anda cari
              <b>tidak ditemukan</b>
            </div>
          </b-alert>

          <b-table
            v-if="this.reports"
            responsive
            striped
            hover
            :items="this.reports"
            :busy.sync="isBusy"
            :fields="fields"
            class="mt-3"
            outlined
          >
            <template #table-busy>
              <div class="text-center text-danger my-2">
                <b-spinner class="align-middle" />
                <strong>Loading...</strong>
              </div>
            </template>
            <template #cell(index)="data">
              <!-- {{ data.index + 1 }} -->
              {{ getOverallIndex(data.index) }}
            </template>
          </b-table>

          <div class="datatable-pager">
            <div class="datatable-pager-info my-2 mb-sm-0">
              <span class="title">Items per Page:</span>
              <select
                class="form-control"
                v-model="pageSize"
                @change="handlePageSizeChange($event)"
              >
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
            </div>
            <b-pagination
              class="datatable-pager-nav my-2 mb-sm-0"
              v-model="page"
              :total-rows="count"
              :per-page="perPage"
              prev-text="Prev"
              next-text="Next"
              @change="handlePageChange"
            />
          </div>
        </div>
        <!--end::Body-->
      </div>
    </div>
  </div>
</template>

<script>
// export to excel
// https://panjiachen.github.io/vue-element-admin-site/feature/component/excel.html#excel-import
// https://github.com/PanJiaChen/vue-element-admin/blob/master/src/views/excel/export-excel.vue
import axios from 'axios'
import { mapGetters, mapActions } from 'vuex'
import store from '@/core/services/store'
import { UPDATE_SELECTED_REGION } from '@/core/services/store/regions.module'

// datepicker
// https://mengxiong10.github.io/vue2-datepicker/index.html#Shortcut
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'

// select region
import Multiselect from 'vue-multiselect'
import { today } from '@/core/helpers/temp/util.js'

export default {
  name: 'table_report',
  components: { DatePicker, Multiselect },
  data() {
    return {
      reports: [],
      searchTitle: '',
      page: 1,
      count: 0,
      pageSize: 25,
      pageSizes: [25, 50, 100, 'All'],

      // table
      sortBy: 'status',
      sortDesc: true,
      isBusy: false,
      fields: [
        'index',
        {
          key: 'provinsi',
          sortable: false,
        },
        {
          key: 'kabupaten',
          sortable: false,
        },
        {
          key: 'tanggal_vaksinasi',
          sortable: false,
        },
        {
          key: 'capaian_harian_dosis_1',
          label: 'Capaian Harian Dosis 1',
          sortable: false,
        },
        {
          key: 'capaian_harian_dosis_2',
          label: 'Capaian Harian Dosis 2',
          sortable: false,
        },
        {
          key: 'capaian_harian_dosis_3',
          label: 'Capaian Harian Dosis 3',
          sortable: false,
        },
        {
          key: 'SDMKES_dosis_1',
          label: 'SDMK Dosis 1',
          sortable: false,
        },
        {
          key: 'SDMKES_dosis_2',
          label: 'SDMK Dosis 2',
          sortable: false,
        },
        {
          key: 'SDMKES_dosis_3',
          label: 'SDMK Dosis 3',
          sortable: false,
        },
        {
          key: 'petugas_publik_dosis_1',
          label: 'Petugas Publik Dosis 1',
          sortable: false,
        },
        {
          key: 'petugas_publik_dosis_2',
          label: 'Petugas Publik Dosis 2',
          sortable: false,
        },
        {
          key: 'petugas_publik_dosis_3',
          label: 'Petugas Publik Dosis 3',
          sortable: false,
        },
        {
          key: 'lansia_dosis_1',
          label: 'Lansia Dosis 1',
          sortable: false,
        },
        {
          key: 'lansia_dosis_2',
          label: 'Lansia Dosis 2',
          sortable: false,
        },
        {
          key: 'lansia_dosis_3',
          label: 'Lansia Dosis 3',
          sortable: false,
        },
        {
          key: 'masy_rentan_umum_dosis_1',
          label: 'Masy Rentan & Umum Dosis 1',
          sortable: false,
        },
        {
          key: 'masy_rentan_umum_dosis_2',
          label: 'Masy Rentan & Umum Dosis 2',
          sortable: false,
        },
        {
          key: 'masy_rentan_umum_dosis_3',
          label: 'Masy Rentan & Umum Dosis 3',
          sortable: false,
        },
        {
          key: 'usia_12-17_dosis_1',
          label: 'Usia 12-17 th Dosis 1',
          sortable: false,
        },
        {
          key: 'usia_12-17_dosis_2',
          label: 'Usia 12-17 th Dosis 2',
          sortable: false,
        },
        {
          key: 'usia_6-11_dosis_1',
          label: 'Usia 6-11 th Dosis 1',
          sortable: false,
        },
        {
          key: 'usia_6-11_dosis_2',
          label: 'Usia 6-11 th Dosis 2',
          sortable: false,
        },
        {
          key: 'tanggal_laporan',
          label: 'Tanggal Laporan',
          sortable: false,
        },
      ],
      isError: false,
      // datepicker
      dateRange: null,
      // download
      filename: 'Data_harian_filtered',
      autoWidth: true,
      bookType: 'xlsx',
    }
  },
  methods: {
    ...mapActions(['updateSelectedRegion']),
    getRequestParams(searchTitle, page, pageSize, dateRange) {
      let params = {}
      if (searchTitle) {
        params['search'] = searchTitle
      }
      if (page) {
        params['page'] = page - 1
      }
      if (pageSize) {
        params['size'] = pageSize !== 'All' ? pageSize : 0
      }
      if (dateRange) {
        params['date_start'] = dateRange[0]
        params['date_end'] = dateRange[1]
      }
      if (this.isRegionReady && this.selectedRegion.region_id != '1') {
        params['region_id'] = this.selectedRegion.region_id
      }
      return params
    },
    retrieveReports() {
      const params = this.getRequestParams(
        this.searchTitle,
        this.page,
        this.pageSize,
        this.dateRange
      )

      this.isBusy = true
      const apiUrl = process.env.VUE_APP_SERVICE_URL
      let promise = axios.get(
        `${apiUrl}/api/cluster_immunization/vc19_reports`,
        {
          params,
        }
      )

      return promise
        .then((response) => {
          // Here we could override the busy state, setting isBusy to false
          this.isBusy = false
          this.isError = false
          // return items
          const { items, totalItems } = response.data
          this.reports = items
          this.count = totalItems
        })
        .catch((error) => {
          // Here we could override the busy state, setting isBusy to false
          this.isBusy = false
          this.isError = true
          this.reports = [] // Returning an empty array, allows table to correctly handle
          console.log(error)
        })
    },
    handlePageChange(value) {
      this.page = value
      this.retrieveReports()
    },
    handlePageSizeChange(event) {
      this.pageSize = event.target.value
      this.page = 1
      this.retrieveReports()
    },
    refreshData() {
      this.searchTitle = ''
      this.page = 1
      this.pageSize = 25
      this.dateRange = null

      const defaultRegion = {
        region_id: '1',
        name: 'INDONESIA',
      }
      store.dispatch(UPDATE_SELECTED_REGION, defaultRegion)

      this.retrieveReports()
    },
    disabledBeforeStartAndAfterToday(date) {
      const start = new Date('2021-3-6')
      const today = new Date()
      today.setHours(0, 0, 0, 0)

      return date < start || date > new Date(today.getTime())
    },
    // select region
    nameWithLang({ name }) {
      return `${name}`
    },
    // select region
    onSelect(option) {
      // this.getIndicatorsData(option.region_id)
      console.log(option)
    },

    // sample: https://stackoverflow.com/questions/57853986/vue-js-index-and-length-resetting-on-each-page
    getOverallIndex: function (index) {
      let result
      if (this.pageSize !== 'All') {
        result = this.page * this.pageSize - this.pageSize + index + 1
      } else {
        result = index + 1
      }
      return result
    },

    handleDownload() {
      this.downloadLoading = true
      import('@/core/helpers/Export2Excel').then((excel) => {
        const tHeader = [
          'Kabupaten',
          'Tanggal Vaksinasi',
          'Capaian Harian Dosis 1',
          'Capaian Harian Dosis 2',
          'Capaian Harian Dosis 3',
          'Lansia Dosis 1',
          'Lansia Dosis 2',
          'Lansia Dosis 3',
          'Petugas Publik Dosis 1',
          'Petugas Publik Dosis 2',
          'Petugas Publik Dosis 3',
          'SDMKES Dosis 1',
          'SDMKES Dosis 2',
          'SDMKES Dosis 3',
          'Masy Rentan & Umum Dosis 1',
          'Masy Rentan & Umum Dosis 2',
          'Masy Rentan & Umum Dosis 3',
          'Usia 12-17 Dosis 1',
          'Usia 12-17 Dosis 2',
          'Usia 6-11 Dosis 1',
          'Usia 6-11 Dosis 2',
          'Tanggal Laporan',
        ]
        const filterVal = [
          'kabupaten',
          'tanggal_vaksinasi',
          'capaian_harian_dosis_1',
          'capaian_harian_dosis_2',
          'capaian_harian_dosis_3',
          'lansia_dosis_1',
          'lansia_dosis_2',
          'lansia_dosis_3',
          'petugas_publik_dosis_1',
          'petugas_publik_dosis_2',
          'petugas_publik_dosis_3',
          'SDMKES_dosis_1',
          'SDMKES_dosis_2',
          'SDMKES_dosis_3',
          'masy_rentan_umum_dosis_1',
          'masy_rentan_umum_dosis_2',
          'masy_rentan_umum_dosis_3',
          'usia_12-17_dosis_1',
          'usia_12-17_dosis_2',
          'usia_6-11_dosis_1',
          'usia_6-11_dosis_2',
          'tanggal_laporan',
        ]
        const list = this.reports
        const data = this.formatJson(filterVal, list)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: this.filename + '_' + today(),
          autoWidth: this.autoWidth,
          bookType: this.bookType,
        })
        this.downloadLoading = false
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j]
        })
      )
    },
  },
  mounted() {
    this.retrieveReports()
  },
  computed: {
    ...mapGetters(['isRegionReady', 'regionOptions', 'selectedRegion']),

    // hack for all page
    perPage() {
      return this.pageSize !== 'All' ? this.pageSize : 99999999
    },
  },
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style scoped>
.list {
  text-align: left;
  max-width: 750px;
  margin: auto;
}
.datatable-pager {
  margin: 0px;
  padding: 1rem 0;
  padding-bottom: 1rem;
  padding-bottom: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-pack: justify;
  -ms-flex-pack: justify;
  justify-content: space-between;
  -ms-flex-wrap: wrap;
  flex-wrap: wrap;
}
.datatable-pager-nav {
  margin: 0;
  margin-top: 0px;
  margin-bottom: 0px;
  padding: 0;
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
}
.datatable-pager-info {
  display: -webkit-box;
  display: -ms-flexbox;
  display: flex;
  -webkit-box-align: center;
  -ms-flex-align: center;
  align-items: center;
}
.datatable-pager-info .title {
  width: 150px;
}

/* datepicker  */
.mx-datepicker-range {
  width: 100%;
}

/* select region */
.select {
  width: 100%;
}
.multiselect,
.multiselect__input,
.multiselect__single {
  font-size: 14px;
}
.multiselect__tags {
  border: 1px solid #e4e6ef;
}
</style>
